
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-storage-services-works",
      function () {
        return require("private-next-pages/how-storage-services-works/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-storage-services-works"])
      });
    }
  